import { ILoggedInUserState } from 'store/loggedInUser/reducer';

export const getName = (state: ILoggedInUserState): string =>
	(state.data?.first_name || state.data?.last_name)
		? `${state.data?.first_name} ${state.data?.last_name}`
		: '';